import { useEffect } from "react";
import { useState } from "react";
import { http, fmtINR } from "@/lib/api";

export default function Distributors() {
    const [rows, setRows] = useState([]);
    useEffect(() => {
        http.get("/masters/distributors").then((r) => setRows(r.data));
    }, []);

    return (
        <div className="mx-auto max-w-[1560px] space-y-4 p-6">
            <div className="flex items-end justify-between">
                <div>
                    <div className="mlabel">Master Data · Distributors</div>
                    <h1 className="text-[22px] font-semibold tracking-tight">Distribution Partners</h1>
                </div>
                <div className="text-[11px] text-muted-foreground">{rows.length} distributors</div>
            </div>

            <div className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-3" data-testid="distributors-grid">
                {rows.map((d) => (
                    <div
                        key={d.id}
                        data-testid={`distributor-${d.id}`}
                        className="hover-lift flex flex-col gap-2 rounded-sm border border-border bg-card p-4"
                    >
                        <div className="flex items-start justify-between">
                            <div>
                                <div className="text-sm font-semibold">{d.name}</div>
                                <div className="mono-num text-[11px] text-muted-foreground">
                                    {d.code} · {d.region}
                                </div>
                            </div>
                            <div className="text-right">
                                <div className="mlabel">Health</div>
                                <div
                                    className={
                                        "mono-num text-lg font-semibold " +
                                        (d.health_score >= 80
                                            ? "text-emerald-600"
                                            : d.health_score >= 60
                                            ? "text-foreground"
                                            : "text-red-500")
                                    }
                                >
                                    {d.health_score}
                                </div>
                            </div>
                        </div>
                        <div className="grid grid-cols-2 gap-3 rounded-sm bg-muted/40 p-2">
                            <div>
                                <div className="mlabel">Credit Limit</div>
                                <div className="mono-num text-[12px] font-semibold">{fmtINR(d.credit_limit)}</div>
                            </div>
                            <div>
                                <div className="mlabel">Outstanding</div>
                                <div className="mono-num text-[12px] font-semibold">{fmtINR(d.outstanding)}</div>
                            </div>
                        </div>
                        <div>
                            <div className="mlabel mb-1">Utilization</div>
                            <div className="h-1.5 overflow-hidden rounded-full bg-border">
                                <div
                                    className="h-full bg-primary"
                                    style={{
                                        width: `${Math.min(100, (d.outstanding / d.credit_limit) * 100)}%`,
                                    }}
                                />
                            </div>
                            <div className="mt-1 text-[10px] text-muted-foreground">
                                {((d.outstanding / d.credit_limit) * 100).toFixed(1)}% of credit
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
